<template>
    <v-row justify="center">
        <v-dialog
            v-model="childDialog"
            :persistent='true'
            max-width="700px"
            height="100%"
            class="modalDialog"
            no-click-animation
        >
            <div class="startTimeBody">
                <v-card class="cardWrap">
                <CardTitle title="枠選択画面"/>
                <div class='golfnametitle'>
                    <span>{{ formatedPlayDate }}</span>
                </div>
                    <v-container>
                        <v-row>
                            <v-col class="text-center">スタート時間</v-col>
                            <v-col class="text-center">コース</v-col>
                            <v-col class="text-center" cols="5">人数</v-col>
                            <v-col class="text-center">備考</v-col>
                        </v-row>
                        <v-row v-for="info in course_time_info" :key="info.id" align="center"
                            v-show="(info.class === 'yes_reserve' && info.open === 1 && info.member_open === 0) ||
                                    (info.open === 0 && info.class === 'yes_reserve') ||
                                    (info.open !== 0 && info.member_open !== 0)"
                        >
                            <v-col :class="info.class + ' text-center'">{{ info.start_time }}</v-col>
                            <v-col :class="info.class + ' text-center'">{{ info.course_status }}</v-col>
                            <v-col cols="5" v-if="info.count.length === 0" class="disabledCell text-center">
                            -
                            </v-col>
                            <v-col cols="5" v-else :class="info.class + ' text-center'">
                                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                    <template v-for="(val, index) in info.count">
                                        <input
                                            :id="`${info.id}-${index + 1}`"
                                            :class="{ 'radio-inline__input': true }"
                                            type="radio"
                                            :name="`accessible-radio-${info.id}`"
                                            @click="selectNumber(info, index + 1, val, $event)"
                                            :key="`${info.id}-${index + 1}-1`"
                                            :disabled="disabledCell(index + 1, info.least_num, info.max_num) || val.click_flag === '3' || val.name !== ''"
                                            :checked="val.click_flag == 1 "
                                        />
                                        <label
                                            class="radio-inline__label"
                                            :for="`${info.id}-${index + 1}`"
                                            :key="`${info.id}-${index + 1}-2`"
                                            :class="{
                                                disabledCell:
                                                    disabledCell(index + 1, info.least_num, info.max_num) ||
                                                    val.click_flag === '3'
                                            }">
                                            <span v-if="val.name === ''">{{ index + 1 }}</span>
                                            <span v-else-if="val.name !== ''">
                                                <svg class="bi bi-person-fill" width="1.5em" height="1.5em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                                                </svg>
                                            </span>
                                        </label>
                                    </template>
                                </div>
                            </v-col>
                            <v-col :class="info.class + ' text-center'">{{ info.remarks }}</v-col>
                        </v-row>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="onClose">閉じる</v-btn>
                        <v-btn color="primary" text @click="displayChangeOverlay">登録</v-btn>
                    </v-card-actions>
                    <ChangeOverlay
                        page-name="予約"
                        @processing="onNext"
                        @cancel="closeChangeOverLay"
                        :process-result="processing"
                        :OverlaySwitch="changeOverlay"
                    />
                </v-card>
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import { GET_PLAN_START_TIME_LIST } from '@/constants/plan';
import ChangeOverlay from '@/components/overlay/ChangeOverlay';
// import { GET_COMPANION_LIST } from '@/constants/companion';
import { GET_CELL_STATUS } from '@/constants/cell_info';
import { REGIST_RESERVE } from '@/constants/reserve';
import { USE_POINT } from '@/constants/point_register';
import { CODE_MASTER } from '../../config';
import { utilityMixin } from '@/mixins/utility';
import CardTitle from '@/components/module/CardTitle';

export default {
    components: {
        CardTitle,
        ChangeOverlay
        //   ExplanationTableDialog,
    },
    props: {
        received: Object,
        childDialog: Boolean
    },
    mixins: [
        utilityMixin
    ],
    data () {
        return {
            selectDate: null,
            plan_date: null,
            planId: '',
            oldPlanId: '',
            playDate: '',
            plan_name: null,
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            memberNo: '',
            // コース時間配列
            course_time_info: [{
                id: '1', // キー
                start_time: '7:49', // スタート時間
                course_status: 'out', // コース名
                least_num: '1', // 選択不可人数（最小人数 - 1）
                remarks: '', // 備考
                member_open: '', // 会員区分公開フラグ（1 :公開 0 :非公開)
                open: '', // 公開フラグ（1 :公開 0 :非公開）
                class: 'no_reserve',
                count: [
                    { id: '1', // キー
                        name: '', // シェア識別（空:通常 空以外:シェア済）
                        click_flag: '0' // 内部用フラグ1 :選択状態 0:未選択状態
                    },
                    { id: '2', name: '', click_flag: '0' },
                    { id: '3', name: '', click_flag: '0' },
                    { id: '4', name: '', click_flag: '0' }
                ]
            }],
            // tmp_time_info: [],
            // コース情報配列
            course_detail_info: {
                plan_name: '',
                golf_course_name: '',
                play_date: '',
                plan_detail: ''
            },
            // プレースタイルアイコン
            play_style_info: {
                mealClass: '',
                cartClass: '',
                guaranteeClass: '',
                caddieClass: '',
                roundClass: '',
                accommodationClass: '',
                shareClass: ''
            },
            // コース料金オブジェクト
            course_detail_fee: {
                one: '',
                sum_up_fee: {
                    two: '0',
                    three: '0',
                    four: '0'
                },
                cancel: ''
            },
            cellIdList: [],
            selectNum: [],
            // courseList: [],
            // courseSort: '',
            reserve_type: false,
            player_info: [
                { id: 1,
                    nickname: '名前', // 名前
                    gender: '男性', // 性別
                    age: '50', // 年代
                    score_level: '90', // スコアレベル
                    introduction: 'プロフィールの内容' }
            ],
            passTo: {
                cellId: '',
                planId: '',
                golfCode: '',
                reserveType: '',
                playDate: '',
                memberNo: '',
                memberClass: '0'
            },
            reserveData: {},
            loadingCount: 0,
            // エラーダイアログ表示フラグ
            showError: false,
            // エラーダイアログの文言
            errorMessage: null,
            changeOverlay: false,
            process: {
                error: '',
                errorText: '',
                result: '',
                resultText: ''
            },
            groupInfo: null,
            // 代表者が予約した枠リスト
            reservedCellList: [],
            // 組数変更で入力された組数
            // groupNum: null,
            processing: {
                result: '',
                resultText: ''
            }
        };
    },
    computed: {
        formatedPlayDate () {
            const date = this.playDate.split(/-/);
            return `${date[0]}年${date[1]}月${date[2]}日`;
        },
        disabledCell (current, min, max) {
            return function (current, min, max) {
                return !(current >= min && current <= max);
            };
        }
    },
    methods: {
        /** ----------------------------------------------
         * プラン枠取得
         * プランに対する枠を取得する
         * ---------------------------------------------- */
        getCourseTimeInfo (planId, targetDate, reserveNo) {
            // プラン枠検索
            this.$apollo.query({
                query: GET_PLAN_START_TIME_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    plan_id: planId,
                    play_date: targetDate,
                    reserve_no: reserveNo
                }
            }).then(res => {
                this.selectNum = [];
                this.setCourseTimeInfo(res.data.getPlanStartTimeList.StartTimeList);
                this.getReserveData();
            }).catch(error => {
                const message = error.message.split(':');
                this.message = message;
                this.$store.commit('loading/setIsLoading', false);
            });
        },
        /** ----------------------------------------------
         * 枠の表示設定
         * ---------------------------------------------- */
        setCourseTimeInfo (startTimeList) {
            let oldCellIdInfoList = [];
            this.course_time_info = [];
            // 変更前のセル情報を取得する。
            const oldGroupInfo = this.groupInfo;
            if (this.groupInfo) {
                for (let j of oldGroupInfo) {
                    oldCellIdInfoList.push({ cellId: j.cell_id, number: j.player_number });
                };
            }
            startTimeList.forEach(list => {
                // 予約者の会員区分とプラン区分を比較し、枠選択に制限をかける
                let memberOpen = '';
                let planMemberClass = list.plan_member_class_code;

                if (planMemberClass.charAt(this.received.memberClass) === '1') {
                    memberOpen = 1;
                } else {
                    memberOpen = 0;
                }

                let listItem = {};
                listItem['id'] = list.cell_id;
                listItem['start_time'] = this.getTimeStr(list.play_start);
                listItem['course_status'] = list.course_name;
                listItem['least_num'] = list.player_min;
                listItem['max_num'] = list.player_max;
                listItem['member_open'] = memberOpen;
                listItem['open'] = list.open_flag;
                listItem['remarks'] = '';
                listItem['class'] = 'no_reserve';

                let numberList = [];
                // シェア予約可能枠の場合
                if (Number(list.reserve_status) === Number(CODE_MASTER.RESERVE_STATUS_SHARE_POSSIBLE)) {
                    let playerNumber = 0;
                    // 予約された時の人数
                    let checked = 0;
                    // 変更の場合
                    if (this.groupInfo) {
                        const cell = oldCellIdInfoList.findIndex(obj => obj.cellId === Number(list.cell_id));
                        if (cell !== -1) {
                            playerNumber = oldCellIdInfoList[cell].number;
                            checked = oldCellIdInfoList[cell].number;
                        }
                    }
                    for (let i = 0; i < 4; i++) {
                        let numberInf = {};
                        numberInf['id'] = i + 1;
                        // 変更の際に,元の予約で選択したセルはクリック可能にする。
                        if (playerNumber !== 0) {
                            numberInf['name'] = '';
                            numberInf['click_flag'] = '0';
                            // 変更する予約で確保した座席数を減算して、シェア予約の残席数に加算する
                            playerNumber--;
                            list.player_left++;
                            // 元の予約で選択したセルをチェック状態にする。
                            if (checked === numberInf['id']) {
                                numberInf['click_flag'] = '1';
                                /** ----------------------------------------------------------------------------------------------------------------------------
                                 * 枠の表示を切り替えるためのフラグをセットする
                                 * click_flag: 0 未選択状態 1 選択状態 3 クリック不可
                                 * id: 人数に表示される枠の番号
                                 * name: いずれかの予約で確保された枠のidがセットされる。変更する予約で確保された枠の時は枠のidをセットしない。cell_idが入っている。
                                 * --------------------------------------------------------------------------------------------------------------------------- */
                                this.selectNum.push({
                                    id: list.cell_id,
                                    number: {
                                        click_flag: '1',
                                        id: numberInf['id'],
                                        name: ''
                                    }
                                });
                                if (this.oldPlanId === this.planId) {
                                    listItem['class'] = 'yes_reserve';
                                    listItem['remarks'] = '予約中';
                                }
                            }
                            numberList.push(numberInf);
                            continue;
                        }
                        // 予約可能席数以下の場合
                        /*
                        if (i < list.player_left) {
                        */

                        // nameにidがセットされると人のアイコンに変わる為、ブランクで表示を切り替える
                        // 最大予約人数を超える枠番号はグレーの番号を表示（クリック不可）
                        if (i >= list.player_max) {
                            numberInf['name'] = '';
                        // 残席数はプラン毎に変わる最大予約人数に合わせる為、減算する
                        // 残席数以下の枠番号は選択可能
                        } else if (i < (list.player_left - (4 - list.player_max))) {
                            numberInf['name'] = '';
                        } else {
                            numberInf['name'] = list.cell_id; // 人のアイコンにする
                        }
                        numberInf['click_flag'] = '0';
                        numberList.push(numberInf);
                    }
                // 通常予約可能の場合
                } else if (Number(list.reserve_status) === Number(CODE_MASTER.RESERVE_STATUS_POSSIBLE)) {
                    for (let i = 1; i <= 4; i++) {
                        var checlClickFlag = '0';
                        if (list.player_left < i) {
                            checlClickFlag = '3';
                        }
                        let numberInf = {};
                        numberInf['id'] = i;
                        numberInf['name'] = '';
                        numberInf['click_flag'] = checlClickFlag;
                        numberList.push(numberInf);
                    }
                // 予約済み
                } else {
                    // 代表者が予約している枠は選択できるようにする
                    if (list.reserve_no === this.received.reserveNo) {
                        var number = null;
                        for (let info of this.groupInfo) {
                            if (Number(list.cell_id) === info.cell_id) {
                                number = info.player_number;
                            }
                        }
                        for (var i = 0; i < 4; i++) {
                            var numberInf = {};
                            numberInf['id'] = i + 1;
                            numberInf['name'] = '';
                            numberInf['click_flag'] = '0';
                            if (numberInf['id'] === number) {
                                numberInf['click_flag'] = '1';
                                this.selectNum.push({
                                    id: list.cell_id,
                                    number: {
                                        click_flag: '1',
                                        id: numberInf['id'],
                                        name: ''
                                    }
                                });
                            }
                            numberList.push(numberInf);
                            if (this.oldPlanId === this.planId) {
                                listItem['class'] = 'yes_reserve';
                                listItem['remarks'] = '予約中';
                            }
                        }
                    } else {
                        // 通常の予約済みはグレーにする
                        listItem['least_num'] = 5;

                        for (let i = 0; i < 4; i++) {
                            let numberInf = {};
                            numberInf['id'] = i + 1;
                            numberInf['name'] = '0'; // 人のアイコンにする
                            numberInf['click_flag'] = '0';
                            numberList.push(numberInf);
                        }
                    }
                }
                listItem['count'] = numberList;

                // 変更画面からの遷移で自分の予約 以外の場合
                if (list.reserve_no !== this.received.reserveNo) {
                    // 9:削除済 もしくは 3:他サイトで予約済の場合
                    if (Number(list.reserve_status) === Number(CODE_MASTER.RESERVE_STATUS_DELETED) || Number(list.reserve_status) === Number(CODE_MASTER.RESERVE_STATUS_OTHER_RESERVED)) {
                        // スキップ
                        return;
                    }

                    // 保証なしプランの場合
                    if (Number(this.received.reserveType) === Number(CODE_MASTER.RESERVE_TYPE_SHARE)) {
                        // 0:WEB予約済み  もしくは  1:通常予約可能の場合
                        if (Number(list.reserve_status) === Number(CODE_MASTER.RESERVE_STATUS_WEB_RESERVED) || Number(list.reserve_status) === Number(CODE_MASTER.RESERVE_STATUS_POSSIBLE)) {
                            // スキップ
                            return;
                        }
                    }

                    // 保証ありプランの場合
                    if (Number(this.received.reserveType) === Number(CODE_MASTER.RESERVE_TYPE_NORMAL)) {
                        // 2:シェア予約可能枠で 1人でも予約があったら場合
                        if (Number(list.reserve_status) === Number(CODE_MASTER.RESERVE_STATUS_SHARE_POSSIBLE) && list.player_left < list.player_max) {
                            // グレーにする
                            // listItem['least_num'] = 5;
                            // 予約不可能な枠のため非表示 2022-03-28
                            return;
                        }
                    }
                }

                this.course_time_info.push(listItem);
            });
        },
        /** ------------------------------------------------------------------------
         * 選択済データ取得処理
         * ------------------------------------------------------------------------- */
        getReserveData  () {
            var cellIdInfoList = this.reserveData.selectCellId;

            for (var i = 0; i < cellIdInfoList.length; i++) {
                const idx = this.course_time_info.findIndex(el => el.id === cellIdInfoList[i].cellId);
                const numIdx = cellIdInfoList[i].number - 1;
                this.course_time_info[idx].count[numIdx].click_flag = '1';

                const obj = {
                    id: cellIdInfoList[i].cellId,
                    number: this.course_time_info[idx].count[numIdx]
                };
                this.selectNum.push(obj);
            }
        },
        /** ----------------------------------------------
         * 枠人数選択処理
         * ---------------------------------------------- */
        selectNumber (info, index, val, el) {
            if (!this.groupInfo && info.id === this.received.cellId) {
                alert('同じ時間帯のものは選択できません。');
                el.target.checked = false;
                return;
            }

            if (val.click_flag === '1') {
                val.click_flag = '0';
                if (el.target.checked === true) {
                    el.target.checked = false;
                }
            } else {
                for (var i = 0; i < info.count.length; i++) {
                    if (info.count[i].click_flag === '1') {
                        info.count[i].click_flag = '0';
                    }
                }
                val.click_flag = '1';
            }
            const obj = {
                id: info.id,
                number: val
            };
            // すでに同じ枠idのものが存在するとき、すでに存在するものを削除する
            const key = this.selectNum.findIndex(el => el.id === info.id);
            if (key !== -1) {
                this.selectNum.splice(key, 1);
            }
            // チェックをONにした場合
            if (val.click_flag === '1') {
                this.selectNum.push(obj);
            }
        },
        /** ----------------------------------------------
        //  * 次へボタン処理処理
        //  *
        //  * ---------------------------------------------- */
        onNext () {
            if (this.selectNum.length === 0) {
                this.showError = true;
                this.$set(this.processing, 'result', '1');
                this.$set(this.processing, 'resultText', 'スタート時間が選択されていません。');
                return;
            }

            var cellIdList = [];
            var cellIdInfoList = [];
            this.selectNum.forEach(select => {
                cellIdInfoList.push({ cellId: select.id, number: select.number.id });
                cellIdList.push(select.id);
            });

            this.cellIdList = cellIdInfoList;

            // 選択枠が予約済みでないか再確認
            this.$apollo.query({
                query: GET_CELL_STATUS,
                fetchPolicy: 'no-cache',
                variables: {
                    cell_id: cellIdList
                }
            }).then(res => {
                // 枠状態を確認する
                if (this.checkCellStatus(res.data.GetCellStatus.CellStatusList, cellIdInfoList) === true) {
                    this.$store.commit('loading/setIsOpacityLoading', true);
                    this.reserveData['selectCellId'] = cellIdInfoList;
                    this.getCellStatus();
                    // 閉じる
                    this.changeOverlay = false;
                    this.$emit('close', this.reserveData);
                } else {
                    this.showError = true;
                    this.$set(this.processing, 'result', '1');
                    this.$set(this.processing, 'resultText', '他の方が既に予約されたため、予約できません。\n もう一度プランの選択から予約してください。');
                }
            }).catch(error => {
                const message = error.message.split(':');
                this.message = message;
            });
        },
        /** ----------------------------------------------
         * 予約情報作成
         * ---------------------------------------------- */
        async RegistReserve () {
            let cells = [];
            let numbers = [];
            let cnt = 0;
            const cellNum = this.cellIdList.length;
            // 通常またはシェア予約の場合
            if (this.received.reserveType === Number(CODE_MASTER.RESERVE_TYPE_NORMAL) ||
                this.received.reserveType === Number(CODE_MASTER.RESERVE_TYPE_SHARE) ||
                this.received.reserveType === Number(CODE_MASTER.RESERVE_TYPE_REQUEST)) {
                this.cellIdList.forEach(list => {
                    cells.push(list.cellId);
                    numbers.push(list.number);
                    cnt = cnt + list.number;
                });
            } else {
                cells.push('0');
            }

            this.$apollo.mutate({
                mutation: REGIST_RESERVE,
                variables: {
                    golf_group_code: this.golfGroupCode,
                    member_no: this.received.memberNo,
                    golf_code: this.received.golfCode,
                    plan_id: this.received.planId,
                    play_date: this.received.playDate,
                    cell_number: cellNum,
                    play_number: cnt,
                    reserve_type: this.received.reserveType,
                    cell_id: cells,
                    cell_player_number: numbers,
                    contact_tel: this.received.telephone,
                    request_first_choice: this.received.requestFirstChoice,
                    request_second_choice: this.received.requestSecondChoice,
                    request_third_choice: this.received.requestThirdChoice,
                    request_contact_info: this.received.requestContactInfo,
                    reserve_no: this.received.reserveNo
                }
            }).then(res => {
                this.reserveNo = res.data.RegisterReserveFromAdmin.reserve_no;
                /* this.CompleteReserveEmailSend(); */
                this.cellIdList = [];
                if (this.usePoint > 0) {
                    this.AddUsePoint(this.reserveNo);
                }
                if (this.reserveNo) {
                    this.successClose(this.reserveNo);
                }
                this.reserveData = {};
                this.$emit('changeDisplayCompanion', true);
                this.changeOverlay = false;
            }).catch(error => {
                error = error.message.split(/:/g);
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', error[0]);
            });
        },
        getCellStatus () {
            let cellList = [];
            let cellIdInfoList = [];
            this.cellIdList.forEach(select => {
                cellIdInfoList.push({ cellId: select.cellId, number: select.number });
                cellList.push(select.cellId);
            });

            // 選択枠が予約済みでないか再確認
            this.$apollo.query({
                query: GET_CELL_STATUS,
                fetchPolicy: 'no-cache',
                variables: {
                    cell_id: cellList
                }
            }).then(res => {
                // 枠状態を確認する
                if (this.checkCellStatus(res.data.GetCellStatus.CellStatusList, cellList) === true) {
                    // 登録処理
                    this.RegistReserve();
                } else {
                    this.valid = true;
                    this.$set(this.processing, 'result', '1');
                    this.$set(this.processing, 'resultText', '他の方が既に予約されたため、予約できません。\n もう一度プランの選択から予約してください。');
                    this.validMessage = '他の方が既に予約されたため、予約できません。\n もう一度プランの選択から予約してください。';
                }
            }).catch(error => {
                const message = error.message.split(':');
                this.message = message;
            });
        },
        /** ----------------------------------------------
         * 枠状態チェック
         * @param {array} cellStatusList 枠状態
         * @param {array} cellIdInfoList 枠選択情報（cellId: 枠ID, number: 人数）
         * ---------------------------------------------- */
        checkCellStatus (cellStatusList, cellIdInfoList) {
            let checkStatus = true;
            var checkStatusList = [];
            // 変更の場合
            let oldCellIdInfoList = [];
            if (this.groupInfo) {
                // 変更前のセル情報を取得する。
                const oldGroupInfo = this.groupInfo;
                for (let j of oldGroupInfo) {
                    oldCellIdInfoList.push({ cellId: j.cell_id, number: j.player_number });
                };
            }
            // 通常予約の場合
            if (this.received.reserveType === Number(CODE_MASTER.RESERVE_TYPE_NORMAL) || this.received.reserveType === Number(CODE_MASTER.RESERVE_TYPE_REQUEST)) {
                cellStatusList.forEach(cellStatus => {
                    // 枠がシェア予約可能でinfoとlinkで残席数が違った場合
                    if (cellStatus.reserve_status === Number(CODE_MASTER.RESERVE_STATUS_SHARE_POSSIBLE) && cellStatus.player_left !== cellStatus.link_player_left) {
                        checkStatus = false;
                    }
                    if (this.groupInfo) {
                        // 既に予約をしていた枠は除外
                        if (this.reservedCellList.includes(Number(cellStatus.cell_id))) {
                            checkStatus = true;
                        }
                    }
                    checkStatusList.push(checkStatus);
                });
            // シェア予約の場合
            } else if (this.received.reserveType === Number(CODE_MASTER.RESERVE_TYPE_SHARE)) {
                cellStatusList.forEach(cellStatus => {
                    cellIdInfoList.forEach(selectInfo => {
                        let num = 0;
                        // 変更の場合
                        if (this.groupInfo) {
                            const cell = oldCellIdInfoList.findIndex(obj => obj.cellId === Number(cellStatus.cell_id));
                            if (cell !== -1) {
                                num = oldCellIdInfoList[cell].number;
                            }
                        }
                        if (cellStatus.cell_id === selectInfo.cellId) {
                            // シェア予約可能で予約可能席数が選択人数より多い場合
                            if (cellStatus.reserve_status === Number(CODE_MASTER.RESERVE_STATUS_POSSIBLE) ||
                                cellStatus.reserve_status === Number(CODE_MASTER.RESERVE_STATUS_SHARE_POSSIBLE)) {
                                if (num !== -1) {
                                    cellStatus.player_left += num;
                                }
                                if (cellStatus.player_left >= selectInfo.number) {
                                } else {
                                    checkStatus = false;
                                }
                            } else {
                                checkStatus = false;
                            }
                        }
                    });
                });
            }

            if (this.groupInfo) {
                // 組の変更時にすでにcheckStatusListに一つでもfalseがあればcheckStatusをfalseにする
                if (checkStatusList.includes(false)) {
                    checkStatus = false;
                }
            }

            return checkStatus;
        },
        /** ----------------------------------------------
         * ポイント利用
         * ---------------------------------------------- */
        AddUsePoint (reserveNumber) {
            this.usePoint = Number(this.usePoint);
            this.loginUserMemberNo = String(this.loginUserMemberNo);
            var actiontext = this.planName + this.selectDateStr + '予約分';
            var data = [{
                point: this.usePoint,
                member_no: this.loginUserMemberNo,
                golf_group_code: process.env.MIX_GROUP_CODE,
                golf_code: this.golfCode,
                use_date: this.selectDateStr,
                action: actiontext,
                reserve_no: reserveNumber
            }];
            this.$apollo.mutate({
                mutation: USE_POINT,
                variables: {
                    PointList: data
                }
            }).then(res => {
                const resp = res.data;
                this.message = resp;
            }).catch(error => {
                this.result = 0;
                this.resultText = this.$t('result.error.add');
                this.error = error;
            });
        },
        /** ------------ ----------------------------------
         * 変更ダイアログを表示する
         * ---------------------------------------------- */
        displayChangeOverlay () {
            this.$set(this.processing, 'result', '');
            this.$set(this.processing, 'resultText', '');
            this.changeOverlay = true;
        },
        /** ----------------------------------------------
         * 変更ダイアログを閉じる
         * ---------------------------------------------- */
        closeChangeOverLay () {
            this.process.result = '';
            this.changeOverlay = false;
        },
        /** ----------------------------------------------
         * コンポーネントを開く処理
         * @param {Array} ダイアログの状態
         * ---------------------------------------------- */
        ModalControl (planId, playDate, reserveType, groupInfo, oldPlanId) {
            var searchReserveNo = null;
            this.planId = planId;
            this.oldPlanId = oldPlanId || '';
            this.playDate = playDate;
            // this.groupNum = groupNum;
            this.received.reserveType = reserveType;
            this.passTo.cellId = this.received.cellId;
            this.passTo.planId = this.received.planId;
            this.passTo.planName = this.received.planName;
            this.passTo.reserveType = this.received.reserveType;
            this.passTo.golfCode = this.received.golfCode;
            this.passTo.reserveNo = this.received.reserveNo;
            this.passTo.playDate = this.received.playDate;
            this.passTo.memberNo = this.received.memberNo;
            this.passTo.reserveType = this.received.reserveType;
            this.passTo.memberClass = this.received.memberClass;
            this.cellIdList.push({ cellId: this.received.cellId, number: this.received.playNumber });
            searchReserveNo = this.received.reserveNo;
            if (groupInfo) {
                this.groupInfo = groupInfo;
                for (let info of groupInfo) {
                    this.reservedCellList.push(info.cell_id);
                }
            }
            this.getCourseTimeInfo(planId, playDate, searchReserveNo);
        },
        successClose (reserveNo) {
            this.course_time_info = [];
            this.CellStatusList = [];
            this.cellIdList = [];
            this.selectNum = [];
            this.$emit('success', reserveNo);
        },
        onClose () {
            this.course_time_info = [];
            this.CellStatusList = [];
            this.cellIdList = [];
            this.selectNum = [];
            this.$emit('close');
        }
    }
};

</script>

<style scoped>
.golfnametitle{
    margin: 10px 0;
    padding: 3px 10px;
    font-size: 23px;
}

.radio-inline__input {
    clip: rect(1px, 1px, 1px, 1px);
    position: absolute !important;
}

.radio-inline__label {
    display: inline-block;
    margin: 0 15px 0 0;
    border:solid black 1px;
    width: 40px;
}

.radio-inline__input:checked + .radio-inline__label {
    background: #c9e5ef;
}

.radio-inline__input:focus + .radio-inline__label {
    outline-color: #4D90FE;
    outline-offset: -2px;
    outline-style: auto;
    outline-width: 5px;
}

.disabledCell{
  background: #dedede;
  opacity: .6;
  pointer-events: none;
}

.row{
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.no_reserve{
    background-color: white;
    height: 48px;
}

.yes_reserve{
    background-color:#ffc546;
    height: 48px;
}
</style>
